import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { MedicalNotificationPayload } from "../medical/notification/notification.types";

export function sendNotification(payload?: MedicalNotificationPayload) {
  const url = ApiEndpoints.notification;
  const request = setHeaderOptions({
    method: "POST",
    ...(payload ? { body: payload } : {}),
  });

  return fetchData<void>(url, request);
}

export function sendTestNotification() {
  return sendNotification();
}
